export const LINK_TYPE_NONE = 'none';
export const LINK_TYPE_EXTERNAL = 'external';
export const LINK_TYPE_INTERNAL = 'internal';
export const LINK_TYPE_OVERLAY = 'overlay';
export const LINK_TYPE_DOWNLOADABLE = 'download';

export const VALID_LINK_TYPES = [
  LINK_TYPE_NONE,
  LINK_TYPE_EXTERNAL,
  LINK_TYPE_INTERNAL,
  LINK_TYPE_OVERLAY,
  LINK_TYPE_DOWNLOADABLE
];
